export default {
  jetlympic: {
    entrance: {
      text_1: '开闭幕式',
      text_2: '比赛',
    },
    home: {
      home_item_1: 'MINI 马拉松 直播',
      home_item_2: '住宿&餐饮信息',
      home_item_3: '赛程查询',
      home_item_4: '接驳车信息',
      home_item_5: '赛事直播',
      home_item_6: '赛事图片',
      home_item_7: '竞赛规程',
      home_item_8: '赛事资讯',
      home_item_9: '赛事数据'
    },
    list: {
      list_item_1: 'MINI马拉松',
      list_item_6: '趣味折返接力赛',
      list_item_2: '篮球',
      list_item_3: '足球',
      list_item_4: '羽毛球',
      list_item_5: '乒乓球'
    },
    hotel: {
      hotel_item_1: '上海浦东康桥绿地假日酒店',
      hotel_item_2: '万信福朋喜来登酒店 (秀沿路地铁站店）',
      hotel_item_3: '维也纳酒店(下沙地铁站店)',
      hotel_item_4: '上海浦东丽呈华廷酒店',
      hotel_item_5: '桔子酒店(申江南路店)',
      hotel_item_6: '上海鹿安花园酒店(迪士尼店)',
      hotel_item_7: '米壹酒店(上海康桥地铁站店)',
    },
    shuttle: {
      text_1: '线路 1',
      text_2: '线路 2',
      text_3: '线路 3',
    },
    video: {
      title_1: '2025第四届Jetlympic运动会开幕式直播 ',
      title_2: '第四届Jetlympic闭幕式暨J&T十周年庆典直播',
      title_3: '2025第四届Jetlympic运动会MINI马拉松直播',
    },
    sportType: {
      "全部": "全部",
      "篮球": "篮球",
      "足球": "足球",
      "羽毛球": "羽毛球",
      "乒乓球": "乒乓球"
    }
  },
  /** OSTASIENSPIELE SHANGHAI 活动入口承载页 */
  osten: {
    home: {
      title_line1: 'OSTASIENSPIELE SHANGHAI',
      title_line2: '2026',
      closing_ceremony: '闭幕式',
      sport_gymnastics: '体操',
      sport_basketball: '篮球',
      sport_football: '足球',
      sport_swimming: '游泳',
      sport_athletics: '田径',
      sport_volleyball: '排球',
      partners_title: '合作伙伴',
      footer: 'POWERED BY BMBSports'
    },
    /** 篮球 / 足球 / 体操二级选择页 */
    subSelect: {
      gymnastics_apr14: '4月14日',
      gymnastics_apr17: '4月17日',
      basketball_women: '女子篮球',
      basketball_men: '男子篮球',
      football_women: '女子足球',
      football_men: '男子足球'
    }
  },
  match: {
    home: {
      button_text: '我要报名'
    },
    registration: {
      button_text: '提交报名资料',
      button_update_text: '更 新'
    },
    personSuccess: {
      text_1: '个人资料创建成功',
      text_update_1: '个人资料编辑成功',
      text_2: '资料编辑',
      text_3: '去赛事主页',
      text_4: '前往'
    },
    homeTabs: {
      text_1: '积分榜',
      text_2: '赛程表',
      text_3: '球队数据',
      text_4: '球员榜',
      text_5: '赛事名次',
      text_6: '参赛名单',
      text_7: '未公布',
      text_8: '球员数据',
      text_9: '更多',
      "得分王": '得分王',
      "助攻王": '助攻王',
      "篮板王": '篮板王',
      "盖帽王": '盖帽王',
      "抢断王": '抢断王'
    },
    standings: {
      text_1: '赛',
      text_2: '胜',
      text_3: '平',
      text_4: '负',
      text_5: '得/失',
      text_6: '积分',
      text_7: '胜率',
      text_8: '场均<br>得分',
      text_9: '场均<br>失分',
      text_10: '场均<br>净胜',
      text_11: '净胜局',
      text_12: '净胜分'
    },
    schedule: {
      text_1: '即将开赛',
      text_2: '斑马直播中',
      text_3: '比赛结束',
      text_4: '视频录像'
    },
    playerList: {
      text_1: '射手',
      text_2: '红黄',
      text_3: '助攻',
      text_4: '球员',
      text_5: '球队',
      text_6: '进球',
      text_7: '红牌',
      text_8: '黄牌',
      text_9: '助攻',
      text_10: '场均',
      text_11: '场次',
      text_12: '篮板',
      text_13: '抢断',
      text_14: '盖帽',
      text_15: '得分',
      text_16: '助攻'
    }
  },
  event: {
    activity: {
      text_1: '时 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 间',
      text_2: '类 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 型',
      text_3: '地 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 址',
      text_4: '视频集锦',
      text_5: '更多',
      text_6: '比赛数据',
      text_7: '球队',
      text_8: '总分'
    }
  },
  attendMatchPlayer: {
    text_1: '球员名单',
  },
  livePage: {
    highlights: '精彩集锦',
    commentTab: '评论',
    all: '全部',
    noVideo: '暂无视频',
    allComments: '所有评论',
    noComment: '暂无评论',
    playing: '播放中',
    commentDisabledLine1: '暂未开通评论',
    commentDisabledLine2: 'Comments are disabled',
    interactionDisabledLine1: '暂未开通互动',
    interactionDisabledLine2: 'Likes and comments are disabled',
    dialogConfirm: '确定',
    commentPopupTitle: '发表评论',
    commentCancel: '取消',
    commentSubmit: '发布',
    commentPlaceholder: '我来说几句...',
    commentEmpty: '请输入评论内容',
    commentSendOk: '发送成功'
  }
}
